export const getIntlUrl = (urlObj: any, locale = 'en', baseUrl = '') => {
  const { url, urlsIntl = {} } = urlObj;
  if (locale === 'en') { return `${baseUrl}${url}`; }
  return `${baseUrl}${urlsIntl[locale] || url}`;
}
